import { createViewFilesList } from "@/ui/views/ViewFilesList";
import type { TViewFilesListUseCases } from "@/ui/views/ViewFilesList";

/**
 * View parameters (injected dependencies).
 *
 * The Archive view reuses the shared file-list useCases contract. It is an
 * Admin-only, read-only listing of archived files — whether the retention sweep
 * archived them or their deal was deactivated.
 */
export type TViewFilesArchiveParams = {
    useCases: () => TViewFilesListUseCases;
};

/**
 * View props (from router/parent).
 */
export type TViewFilesArchiveProps = Record<string, never>;

/**
 * Creates the Archive list view (all archived file types, Admin only).
 */
export const createViewFilesArchive = ({ useCases }: TViewFilesArchiveParams) =>
    createViewFilesList({
        title: "Archive",
        description: "Files archived after 3 months, or because their deal was deactivated",
        errorTitle: "Failed to load archived files",
        emptyTitle: "No archived files",
        emptyDescription:
            "Files older than 3 months are archived here automatically, as are the files " +
            "of a deal that has been deactivated.",
        // Only this listing shows why and when a file was archived. The other three
        // never contain an archived row, so the columns would always be empty there.
        showArchiveColumns: true,
    })({ useCases });
